// Report.js
import React from "react"

import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
} from "@react-pdf/renderer"
import {
  getDateFn,
  getTaxableAmt,
  enum_GstType,
  getTotalAmtToShow,
  getAmountToWords,
  getInvoiceHead,
  getGstTax,
  getItemQty,
  getTotalGstAmt,
  getGSTPer,
  getIrnNo,
} from "./ReportUtility"

//const border_color = "gray"
const bg_color = "silver"

const styles = StyleSheet.create({
  page: {
    flexDirection: "row",
    backgroundColor: "#ffffff",
    fontFamily: "Helvetica",

  },
  section: {
    margin: 20,
    padding: 0,
    border: "1px",
    flexGrow: 1,
    fontSize: "9px",
  },
  d_header: {
    fontSize: "10px",
    padding: "3px",
    textAlign: "center",
  },
  t_comptitle: {
    fontSize: "20px",
    textAlign: "center",
    textTransform: "uppercase",
    fontWeight: "bold",
    padding: "5px",
  },
  mainflexdiv: {
    border: "1px",
    borderColor: "#000000",
    width: "50%",
    padding: "2px 2px 0px 2px",
  },
  dflex: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "top",
  },
  dflexbox: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around",
    alignItems: "top",
  },
  item_box_head: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    textAlign: "center",
    padding: "5px",
    flexWrap: "wrap",
    color: "black",
  },
  t_withbg: {
    backgroundColor: bg_color,
    color: "black",
    padding: "5px",
  },
  title: {
    textAlign: "left",
    overflow: "hidden",
    padding: "4px",
    fontSize: "10px",


  },

  title_size: {
    width: "100%",
    textAlign: "right",

  },
  per_size: {
    width: "30%",
    textAlign: "center",

  },
  title_amt: {
    textAlign: "right"
  },
  dtotal: {
    backgroundColor: bg_color,
    padding: " 4px 0px",
    borderRadius: "25px",
    textAlign: "center",
    border: "1px solid black",
    margin: "5px  0px ",
    fontFamily: "Helvetica-Bold",

  },

  srno: {
    width: "5%",
  },
  desc: {
    width: "25%",
  },
  hsno: {
    width: "10%",
  },
  qty: {
    width: "10%",
  },
  discper: {
    width: "8%",
  },
  discamt: {
    width: "7%",
  },
  taxamt: {
    width: "10%",
  },
  unit: {
    width: "7%",
  },
  rate: {
    width: "8%",
  },
  amount: {
    width: "10%",
  },

  font_bold: {
    fontFamily: "Helvetica-Bold",

  },
  table: {
    display: 'table',
    width: '100%',
  },
  tableRow: {
    margin: 'auto',
    flexDirection: 'row',
    width: '100%'
  },
  tableCol: {
    width: '100%',
    padding: "3px 0px"

  },
  tbl_color: {
    backgroundColor: bg_color,
    color: "black",
  },
  tableColItem: {
    fontSize: "9px",
    paddingTop: "3px",

  },
  tableCellItem: {
    textAlign: "center",
    paddingBottom: "1px"

  },
  colBorder: { borderRight: "1px", borderBottom: "1px solid #ebeaeb" },
  tableCellRight: {

    textAlign: "justify",
    paddingLeft: "3px"

  },
  first_colWidth: {
    width: "25%"
  },
  second_colWidth: {
    width: "65%"
  },
  middle_colWidth: {
    width: "5%"
  },
  first_colWidth2: {
    width: "35%"
  },
  font_size: {
    fontSize: "8px"
  },
  row_data: {
    lineHeight: "2"
  },
  bank_width: {
    width: "30%",
  },
  gstBoxRow: {
    borderBottom: "0px solid gray",
    padding: "1px 0px",
    fontSize: "9px"
  }
})

// Create PDF component
const RptDbcrNote = ({ detail }) => {
  let totalQty = 0
  //let totalAmt = 0
  let totalInvAmt = 0
  let totalAmtBeforetax = 0
  let data = []

  if (detail && detail?.length > 0)
    data = detail.filter((val, ind) => ind === 0) //
  return (
    <Document pageMode="fullScreen">
      <Page size="A4" style={styles.page}>
        {data && data.map((item, index) => {
          totalInvAmt = getTotalAmtToShow(item?.NetAmt, item?.TCSAMT)
          return (
            <>
              <View style={styles.section}>
                {/* HEader */}
                <View>
                  <div style={styles.d_header}>
                    <div>
                      <Text style={styles.t_comptitle}>{item.compname}</Text>
                    </div>
                    <div>
                      <Text>
                        {item.comp_add1 +
                          " " +
                          item.comp_add2 +
                          " " +
                          item.comp_add3 +
                          " " +
                          item.comp_add4}
                      </Text>
                    </div>
                    <div>
                      <div>
                        <Text>
                          Contact No :
                          {item.comp_contectno1 + " , " + item.comp_contectno2}
                          <Text style={{ marginLeft: "5px" }}>
                            {item.comp_email_id != ""
                              ? " Email:" + item.comp_email_id
                              : ""}
                          </Text>
                        </Text>
                      </div>
                    </div>
                  </div>
                  {/* end header */}
                  {/* Invoice */}
                  <div style={styles.t_withbg}>
                    <div style={styles.dflex}>
                      <div>
                        <Text>PAN No :{item.PAN_No}</Text>
                      </div>
                      <div>
                        <Text>{getInvoiceHead(item.Bill_Type, item.entry_type, item.DOC_FOR)} </Text>
                      </div>
                      <div>
                        <Text>
                          <Text>GST No :{item.Comp_GST_No}</Text>
                        </Text>
                      </div>
                    </div>
                  </div>
                  {/* /end invoice */}
                  {/* //bill section */}

                  <div style={styles.dflexbox}>
                    <div style={styles.mainflexdiv}>
                      <View style={[styles.table, styles.font_bold, { fontSize: "8px" }]}>
                        <View style={[styles.tableRow]}>
                          <View style={[styles.tableCol, styles.first_colWidth]}>
                            <Text style={[styles.tableCellRight, styles.font_size]}>Name</Text>
                          </View>
                          <View style={[styles.tableCol, styles.middle_colWidth]}>
                            <Text style={[styles.tableCellRight, styles.font_size]}>:</Text>
                          </View>
                          <View style={[styles.tableCol, styles.Second_colWidth, { height: "20px", overflow: "hidden" }]}>
                            <Text style={styles.tableCell}> {item?.PAc_Desc}</Text>
                          </View>
                        </View>
                        <View style={[styles.tableRow]}>
                          <View style={[styles.tableCol, styles.first_colWidth,]}>
                            <Text style={[styles.tableCellRight, styles.font_size]}>Address </Text>
                          </View>
                          <View style={[styles.tableCol, styles.middle_colWidth]}>
                            <Text style={[styles.tableCellRight, styles.font_size]}>:</Text>
                          </View>
                          <View style={[styles.tableCol, styles.Second_colWidth, { height: "50px", overflow: "hidden" }]}>
                            <Text style={styles.tableCell}>  {item?.PAdd_1 + item?.PAdd_2 + item?.PAdd_3}</Text>
                          </View>
                        </View>
                        <View style={[styles.tableRow]}>
                          <View style={[styles.tableCol, styles.first_colWidth]}>
                            <Text style={[styles.tableCellRight, styles.font_size]}>GST No </Text>
                          </View>
                          <View style={[styles.tableCol, styles.middle_colWidth]}>
                            <Text style={[styles.tableCellRight, styles.font_size]}>:</Text>
                          </View>
                          <View style={[styles.tableCol, styles.Second_colWidth]}>
                            <Text style={styles.tableCell}> {item?.Party_GST_No}</Text>
                          </View>
                        </View>
                        <View style={[styles.tableRow]}>
                          <View style={[styles.tableCol, styles.first_colWidth]}>
                            <Text style={[styles.tableCellRight, styles.font_size]}>state </Text>
                          </View>
                          <View style={[styles.tableCol, styles.middle_colWidth]}>
                            <Text style={[styles.tableCellRight, styles.font_size]}>:</Text>
                          </View>
                          <View style={[styles.tableCol, styles.Second_colWidth, { display: "flex" }]}>
                            <Text style={[styles.tableCell]}><Text style={{ width: "50%" }}> {item?.PState + "                       "}</Text>
                              <Text style={{}}>State Code :</Text>
                              <Text style={styles.tableCell}> {item?.PState_Id}</Text>
                            </Text>
                          </View>
                        </View>
                      </View>

                    </div>

                    <div style={styles.mainflexdiv}>
                      <View style={[styles.table, { fontSize: "9px" }]}>
                        <View style={[styles.tableRow]}>
                          <View style={[styles.tableCol, styles.first_colWidth2]}>
                            <Text style={[styles.tableCellRight, styles.font_size1]}>Note Date</Text>
                          </View>
                          <View style={[styles.tableCol, styles.middle_colWidth]}>
                            <Text style={[styles.tableCellRight, styles.font_size]}>:</Text>
                          </View>
                          <View style={[styles.tableCol, styles.Second_colWidth]}>
                            <Text style={[styles.font_bold, styles.tableCell]}> {getDateFn(item?.Bill_Date)}</Text>
                          </View>
                        </View>
                        <View style={[styles.tableRow]}>
                          <View style={[styles.tableCol, styles.first_colWidth2]}>
                            <Text style={[styles.tableCellRight, styles.font_size1]}>Document No</Text>
                          </View>
                          <View style={[styles.tableCol, styles.middle_colWidth]}>
                            <Text style={[styles.tableCellRight, styles.font_size]}>:</Text>
                          </View>
                          <View style={[styles.tableCol, styles.Second_colWidth, { textTransform: "uppercase" }]}>
                            <Text style={[styles.tableCell, styles.font_bold]}>  {item?.Bill_No}</Text>
                          </View>
                        </View>
                        <View style={[styles.tableRow]}>
                          <View style={[styles.tableCol, styles.first_colWidth2]}>
                            <Text style={[styles.tableCellRight, styles.font_size1]}>Party's Doc No</Text>
                          </View>
                          <View style={[styles.tableCol, styles.middle_colWidth]}>
                            <Text style={[styles.tableCellRight, styles.font_size]}>:</Text>
                          </View>
                          <View style={[styles.tableCol, styles.Second_colWidth]}>
                            <Text style={styles.tableCell}>{item?.Chal_No}</Text>
                          </View>
                        </View>
                        <View style={[styles.tableRow]}>
                          <View style={[styles.tableCol, styles.first_colWidth2]}>
                            <Text style={[styles.tableCellRight, styles.font_size1]}>State </Text>
                          </View>
                          <View style={[styles.tableCol, styles.middle_colWidth]}>
                            <Text style={[styles.tableCellRight, styles.font_size]}>:</Text>
                          </View>
                          <View style={[styles.tableCol, styles.Second_colWidth]}>
                            <Text style={[styles.tableCell, styles.font_bold]}>{item?.comp_State}
                            </Text>
                          </View>

                        </View>
                        <View style={[styles.tableRow]}>
                          <View style={[styles.tableCol, styles.first_colWidth2]}>
                            <Text style={[styles.tableCellRight, styles.font_size1]}>State Code </Text>
                          </View>
                          <View style={[styles.tableCol, styles.middle_colWidth]}>
                            <Text style={[styles.tableCellRight, styles.font_size]}>:</Text>
                          </View>
                          <View style={[styles.tableCol, styles.Second_colWidth]}>
                            <Text style={[styles.tableCell, styles.font_bold]}>{item?.comp_stae_id}
                            </Text>
                          </View>

                        </View>
                      </View>

                    </div>
                  </div>
                </View>
                {/* /*EndBilll_section */}
                {/* Main section */}
                <div style={{}}>
                  <View style={[styles.table]}>
                    <View style={[styles.tableRow, styles.font_bold, { borderBottom: "1px" }]}>
                      <View style={[styles.tableColItem, styles.srno, styles.colBorder]}>
                        <Text style={[styles.tableCellItem]}>No</Text>
                      </View>
                      <View style={[styles.tableColItem, styles.desc, styles.colBorder]}>
                        <Text style={[styles.tableCellItem]}>Item Description</Text>
                      </View>
                      <View style={[styles.tableColItem, styles.hsno, styles.colBorder]}>
                        <Text style={[styles.tableCellItem]}>HSN No</Text>
                      </View>
                      <View style={[styles.tableColItem, styles.qty, styles.colBorder]}>
                        <Text style={[styles.tableCellItem]}>Qty.</Text>
                      </View>
                      <View style={[styles.tableColItem, styles.unit, styles.colBorder]}>
                        <Text style={[styles.tableCellItem]}>Unit</Text>
                      </View>
                      <View style={[styles.tableColItem, styles.rate, styles.colBorder]}>
                        <Text style={[styles.tableCellItem]}>Rate</Text>
                      </View>
                      <View style={[styles.tableColItem, styles.amount, styles.colBorder]}>
                        <Text style={[styles.tableCellItem]}>Amount</Text>
                      </View>
                      <View style={[styles.tableColItem, styles.colBorder, styles.discper]}>
                        <Text style={[styles.tableCellItem]}>Disc %</Text>
                      </View>
                      <View style={[styles.tableColItem, styles.discamt, styles.colBorder]}>
                        <Text style={[styles.tableCellItem, { paddingBottom: "6px" }]}>Disc Amount</Text>
                      </View>
                      <View style={[styles.tableColItem, styles.taxamt, styles.colBorder]}>
                        <Text style={[styles.tableCellItem]}>Taxable Amount</Text>
                      </View>
                    </View>
                  </View>
                  <div style={{ minHeight: "295px" }}>
                    <View style={[styles.table,]}>
                      {detail.map((itemlist, inx) => {
                        totalQty += getItemQty(
                          itemlist?.Item_Unit,
                          itemlist?.Bill_D_Meter,
                          itemlist?.Bill_D_Nos,
                          itemlist?.Bill_D_Weight
                        )
                       // totalAmt += itemlist.Amount
                        totalAmtBeforetax += getTaxableAmt(itemlist?.Amount, itemlist?.bill_d_discamt)
                        return (
                          <View style={[styles.tableRow]}>
                            <View style={[styles.tableColItem, styles.srno, styles.colBorder]}>
                              <Text style={[styles.tableCellItem, styles.row_data]}>{(inx += 1)}</Text>
                            </View>
                            <View style={[styles.tableColItem, styles.desc, styles.colBorder]}>
                              <Text style={[styles.tableCellItem, styles.row_data,{fontSize:"8px"}]}>{itemlist?.Item_Det && itemlist?.Item_Det!=""?itemlist?.Item_Det: itemlist?.Item_Desc}</Text>
                            </View>
                            <View style={[styles.tableColItem, styles.hsno, styles.colBorder]}>
                              <Text style={[styles.tableCellItem, styles.row_data]}>{itemlist?.HSNNo}</Text>
                            </View>
                            <View style={[styles.tableColItem, styles.qty, styles.colBorder]}>
                              <Text style={[styles.tableCellItem, styles.row_data, { textAlign: "right", paddingRight: "3px" }]}>{getItemQty(
                                itemlist?.Item_Unit,
                                itemlist?.Bill_D_Meter,
                                itemlist?.Bill_D_Nos,
                                itemlist?.Bill_D_Weight
                              )}</Text>
                            </View>

                            <View style={[styles.tableColItem, styles.unit, styles.colBorder]}>
                              <Text style={[styles.tableCellItem, styles.row_data]}>{itemlist?.Item_Unit}</Text>
                            </View>
                            <View style={[styles.tableColItem, styles.rate, styles.colBorder]}>
                              <Text style={[styles.tableCellItem, styles.row_data, { textAlign: "right", paddingRight: "3px" }]}>{itemlist?.Rate}</Text>
                            </View>
                            <View style={[styles.tableColItem, styles.amount, styles.colBorder]}>
                              <Text style={[styles.tableCellItem, styles.row_data, { textAlign: "right", paddingRight: "3px" }]}>{itemlist?.Amount}</Text>
                            </View>
                            <View style={[styles.tableColItem, styles.discper, styles.colBorder]}>
                              <Text style={[styles.tableCellItem, styles.row_data]}>{itemlist?.Bill_D_DiscPer}</Text>
                            </View>
                            <View style={[styles.tableColItem, styles.discamt, styles.colBorder]}>
                              <Text style={[styles.tableCellItem, styles.row_data]}>{itemlist?.bill_d_discamt}</Text>
                            </View>
                            <View style={[styles.tableColItem, styles.taxamt, styles.colBorder]}>
                              <Text style={[styles.tableCellItem, styles.row_data, { textAlign: "right", paddingRight: "5px" }]}>{getTaxableAmt(itemlist?.Amount, itemlist?.bill_d_discamt)}</Text>
                            </View>
                          </View>

                        )
                      })}
                    </View>
                  </div>
                  <View style={[styles.table, styles.tbl_color]}>
                    <View style={[styles.tableRow, { borderTop: "1px", lineHeight: "2" }, styles.font_bold]}>
                      <View style={[styles.tableColItem, styles.srno, styles.colBorder]}>
                        <Text style={[styles.tableCellItem]}></Text>
                      </View>
                      <View style={[styles.tableColItem, styles.desc, styles.colBorder]}>
                        <Text style={[styles.tableCellItem]}>Total</Text>
                      </View>
                      <View style={[styles.tableColItem, styles.hsno, styles.colBorder]}>
                        <Text style={[styles.tableCellItem]}></Text>
                      </View>
                      <View style={[styles.tableColItem, styles.qty, styles.colBorder]}>
                        <Text style={[styles.tableCellItem, { textAlign: "right", paddingRight: "3px" }]}>{totalQty}</Text>
                      </View>
                      <View style={[styles.tableColItem, styles.unit, styles.colBorder]}>
                        <Text style={[styles.tableCellItem]}></Text>
                      </View>
                      <View style={[styles.tableColItem, styles.rate, styles.colBorder]}>
                        <Text style={[styles.tableCellItem]}></Text>
                      </View>
                      <View style={[styles.tableColItem, { width: "30%" }]}>
                        <Text style={[styles.tableCellItem]}>Total Amount Before Tax</Text>
                      </View>
                      <View style={[styles.tableColItem, styles.taxamt, styles.colBorder]}>
                        <Text style={[styles.tableCellItem, { textAlign: "right", paddingRight: "5px" }]}>{totalAmtBeforetax}</Text>
                      </View>
                    </View>
                  </View>


                  {/* End itemFooter  */}
                </div>
                {/* /End main */}
                {/* footrer */}
                <View style={[styles.table]}>
                  <View style={[styles.tableRow,]}>
                    <View style={[styles.tableCol, styles.mainflexdiv, { width: "62%" }]}>
                      <View style={[styles.table, { borderBottom: "1px" }]}>
                        <View style={[styles.tableRow, styles.font_bold]}>
                          <View style={[styles.tableCol,]}>
                            <Text style={[styles.tableCell, { fontSize: "8px" }]}>Total  Amount In Word</Text>
                          </View>
                        </View>
                        <View style={[styles.tableRow, styles.font_bold,]}>
                          <View style={[styles.tableCol, { height: "20px" }]}>
                            <Text style={[styles.tableCell]}>{"Rs." + getAmountToWords(totalInvAmt) + " Only."}</Text>
                          </View>
                        </View>
                        <View style={[styles.tableRow]}>
                          <View style={[styles.tableCol,]}>
                            <Text style={[styles.tableCell, { height: "12px", fontSize: "8px" }]}>{"Remark:" + item.Remark}</Text>
                          </View>
                        </View>
                      </View>
                      <View style={[styles.table, { borderBottom: "1px" }]}>
                        <View style={[styles.tableRow,]}>
                          <View style={[styles.tableCol, styles.bank_width, styles.font_bold]}>
                            <Text style={[styles.tableCell, styles.font_size]}>Bank Name</Text>
                          </View>
                          <View style={[styles.tableCol, styles.font_bold, styles.middle_colWidth]}>
                            <Text style={[styles.tableCell,]}>:</Text>
                          </View>
                          <View style={[styles.tableCol,]}>
                            <Text style={[styles.tableCell]}>{item.BankName}</Text>
                          </View>
                        </View>
                        <View style={[styles.tableRow,]}>
                          <View style={[styles.tableCol, styles.font_bold, styles.bank_width]}>
                            <Text style={[styles.tableCell, styles.font_size]}>A/C No </Text>
                          </View>
                          <View style={[styles.tableCol, styles.font_bold, styles.middle_colWidth]}>
                            <Text style={[styles.tableCell,]}>:</Text>
                          </View>
                          <View style={[styles.tableCol,]}>
                            <Text style={[styles.tableCell]}>{item.BankAccNo}</Text>
                          </View>
                        </View>
                        <View style={[styles.tableRow,]}>
                          <View style={[styles.tableCol, styles.font_bold, styles.bank_width]}>
                            <Text style={[styles.tableCell, styles.font_size]}>IFSC Code</Text>
                          </View>
                          <View style={[styles.tableCol, styles.font_bold, styles.middle_colWidth]}>
                            <Text style={[styles.tableCell,]}>:</Text>
                          </View>
                          <View style={[styles.tableCol,]}>
                            <Text style={[styles.tableCell]}>{item.BankIFSCCode}</Text>
                          </View>
                        </View>
                        <View style={[styles.tableRow,]}>
                          <View style={[styles.tableCol, styles.font_bold, styles.bank_width]}>
                            <Text style={[styles.tableCell, styles.font_size]}>Bank Address</Text>
                          </View>
                          <View style={[styles.tableCol, styles.font_bold, styles.middle_colWidth]}>
                            <Text style={[styles.tableCell,]}>:</Text>
                          </View>
                          <View style={[styles.tableCol,]}>
                            <Text style={[styles.tableCell]}>{item.BankAddress}</Text>
                          </View>
                        </View>
                      </View>
                      <View style={[styles.font_bold]}>
                        <Text style={[{ fontSize: "9px", lineHeight: "1.5", textAlign: "center" }]}>e-Invoice Detail</Text>
                      </View>
                      <View style={[styles.table]}>
                        <View style={[styles.tableRow, { height: "30px", overflow: "hidden" }]}>
                          <View style={[styles.tableCol, { width: "20%" }]}>
                            <Text style={[styles.tableCell, styles.font_size]}>IRN NO.</Text>
                          </View>
                          <View style={[styles.tableCol,]}>
                            <Text style={[styles.tableCell,]}>{item.EINV_IRN && item.EINV_I != null ? getIrnNo(item.EINV_IRN, 1) + " " + getIrnNo(item.EINV_IRN, 2) : ""}</Text>
                          </View>
                        </View>
                        <View style={[styles.tableRow,]}>
                          <View style={[styles.tableCol, { width: "20%" }]}>
                            <Text style={[styles.tableCell, styles.font_size]}>ACK NO</Text>
                          </View>
                          <View style={[styles.tableCol,]}>
                            <Text style={[styles.tableCell,]}>{item.EINV_ACKNO && item.EINV_ACKNO != null ? item.EINV_ACKNO : ""}</Text>
                          </View>
                        </View>
                        <View style={[styles.tableRow,]}>
                          <View style={[styles.tableCol, { width: "20%" }]}>
                            <Text style={[styles.tableCell, styles.font_size]}>ACK Date</Text>
                          </View>
                          <View style={[styles.tableCol,]}>
                            <Text style={[styles.tableCell,]}>{item.EINV_ACKDATE ? getDateFn(item.EINV_ACKDATE) : ""}</Text>
                          </View>
                        </View>
                      </View>
                      <View style={[styles.font_bold]}>
                        <Text style={[{ lineHeight: "2", marginTop: "10px" }]}>Subject to Surat Jurisdiction</Text>
                      </View>
                      <View style={[]}>
                        <Text style={[{ fontSize: "10px", marginTop: "32px" }]}>Received By __________________________________</Text>
                      </View>
                    </View>
                    <View style={[styles.tableCol, styles.mainflexdiv, { width: "38%" }]}>
                      <View style={[styles.table,]}>
                        {item?.Other_AddAmt && item?.Other_AddAmt > 0 ?
                          <View style={[styles.tableRow, styles.gstBoxRow, styles.font_bold]}>
                            <View style={[styles.tableCol, styles.title_size]}>
                              <Text style={[styles.tableCell,]}>Freight Amount</Text>
                            </View>
                            <View style={[styles.tableCol, styles.per_size]}>
                              <Text style={[styles.tableCell,]}></Text>
                            </View>
                            <View style={[styles.tableCol, {}]}>
                              <Text style={[styles.tableCell, styles.title_amt]}>{item?.Other_AddAmt}
                              </Text>
                            </View>
                          </View> : ""}
                        <View style={[styles.tableRow, styles.gstBoxRow, styles.font_bold]}>
                          <View style={[styles.tableCol, styles.title_size]}>
                            <Text style={[styles.tableCell,]}> Add C.G.S.T @</Text>
                          </View>
                          <View style={[styles.tableCol, styles.per_size]}>
                            <Text style={[styles.tableCell,]}> {getGSTPer(item?.Trade_Type, enum_GstType.CGST)
                              ? + item.bill_d_stper && item.bill_d_stper != null ? item.bill_d_stper + " %" : "0%"
                              : " 0 %"}</Text>
                          </View>
                          <View style={[styles.tableCol, {}]}>
                            <Text style={[styles.tableCell, styles.title_amt]}>{getGstTax(item?.Trade_Type, enum_GstType.CGST)
                              ? item?.STAmt && item?.STAmt != null ? item?.STAmt : "0"
                              : " 0 "}</Text>
                          </View>
                        </View>
                        <View style={[styles.tableRow, styles.gstBoxRow, styles.font_bold]}>
                          <View style={[styles.tableCol, styles.title_size]}>
                            <Text style={[styles.tableCell,]}>Add S.G.S.T @</Text>
                          </View>
                          <View style={[styles.tableCol, styles.per_size]}>
                            <Text style={[styles.tableCell,]}>{getGSTPer(item?.Trade_Type, enum_GstType.SGST)
                              ? item.bill_d_stper && item.bill_d_stper != null ? item.bill_d_stper + " %" : "0 %"
                              : "0 %"}</Text>
                          </View>
                          <View style={[styles.tableCol,]}>
                            <Text style={[styles.tableCell, styles.title_amt]}>{getGstTax(item?.Trade_Type, enum_GstType.SGST)
                              ? item?.ASTAMT && item?.ASTAMT != null ? item?.ASTAMT : "0"
                              : "0"}</Text>
                          </View>
                        </View>
                        <View style={[styles.tableRow, styles.gstBoxRow, styles.font_bold, { borderBottom: "1px solid black" }]}>
                          <View style={[styles.tableCol, styles.title_size]}>
                            <Text style={[styles.tableCell,]}>Add I.G.S.T  @</Text>
                          </View>
                          <View style={[styles.tableCol, styles.per_size]}>
                            <Text style={[styles.tableCell,]}>{getGSTPer(item?.Trade_Type, enum_GstType.IGST)
                              ? item.bill_d_stper && item.bill_d_stper != null ? item.bill_d_stper + " %" : "0 "
                              : "0 %"}</Text>
                          </View>
                          <View style={[styles.tableCol,]}>
                            <Text style={[styles.tableCell, styles.title_amt]}>{getGstTax(item?.Trade_Type, enum_GstType.IGST)
                              ? item?.STAmt && item?.STAmt != null ? item?.STAmt : "0"
                              : "0 "}</Text>
                          </View>
                        </View>
                        <View style={[styles.tableRow, styles.gstBoxRow, styles.font_bold]}>
                          <View style={[styles.tableCol, styles.title_size,]}>
                            <Text style={[styles.tableCell,]}>Total Tax </Text>
                          </View>
                          <View style={[styles.tableCol,]}>
                            <Text style={[styles.tableCell,]}> Amount:GST</Text>
                          </View>
                          <View style={[styles.tableCol,]}>
                            <Text style={[styles.tableCell, styles.title_amt]}>{item?.Trade_Type != "OGS" ? getTotalGstAmt(
                              item.STAmt,
                              item.ASTAMT

                            ) : item.STAmt ? item.STAmt : 0}</Text>
                          </View>
                        </View>
                        <View style={[styles.table,]}>
                          <View style={[styles.tableRow, styles.dtotal,]}>
                            <View style={[styles.tableCol, styles.title_size, { textAlign: "center", marginLeft: "15px" }]}>
                              <Text style={[styles.tableCell,]}>Total Invoice Amount:</Text>
                            </View>
                            <View style={[styles.tableCol, styles.title_amt, styles.font_bold, { paddingRight: "15px", fontSize: "10px" }]}>
                              <Text style={[styles.tableCell,]}>
                                {item?.NetAmt}
                                {/* {getTotalInvoiceAmtSaleBill(item?.NetAmt, item?.TCSAMT)}  */}
                              </Text>
                            </View>
                          </View>

                          <View style={[styles.tableRow, { padding: "0px 15px" },]}>
                            <View style={[styles.tableCol, styles.title_size]}>
                              <Text style={[styles.tableCell, { textAlign: "left" }]}>{item?.TCSAMT && item?.TCSAMT > 0 ? "Add TCS @ " + item?.TCSPER + " % " : ""} </Text>
                            </View>
                            <View style={[styles.tableCol, styles.title_amt, styles.font_bold]}>
                              <Text style={[styles.tableCell,]}>{item?.TCSAMT && item?.TCSAMT > 0 ? item?.TCSAMT : ""}</Text>
                            </View>
                          </View>

                          <View style={[styles.tableRow, styles.font_bold, { fontSize: "10px", padding: "0px 15px", }]}>
                            <View style={[styles.tableCol, styles.title_size]}>
                              <Text style={[styles.tableCell, { textAlign: "left" }]}>{item?.TCSAMT && item?.TCSAMT > 0 ? "Total Amount" : ""}</Text>
                            </View>
                            <View style={[styles.tableCol, styles.title_amt, styles.font_bold]}>
                              <Text style={[styles.tableCell,]}>{item?.TCSAMT && item?.TCSAMT > 0 ? getTotalAmtToShow(item?.NetAmt, item?.TCSAMT,) : ""}</Text>
                            </View>
                          </View>
                          <View style={[styles.tableRow1, { borderTop: "0px dashed black" }]}>
                          </View>
                          <View style={[styles.tableRow,  { borderTop: "0px dashed black", padding: "0px 15px 0px 10px" }]}>
                            <View style={[styles.tableCol, styles.title_size]}>
                              <Text style={[styles.tableCell, { textAlign: "left" }]}>{item?.ExtTDSAmt && item?.ExtTDSAmt > 0 ? "TDS @ " + item?.TDSPer + " % " : ""}</Text>
                            </View>
                            <View style={[styles.tableCol, styles.title_amt,]}>
                              <Text style={[styles.tableCell,]}>{item?.ExtTDSAmt && item?.ExtTDSAmt > 0 ? item?.ExtTDSAmt : ""}</Text>
                            </View>
                          </View>
                        </View>


                      </View>

                      <View style={[ {
                        borderTop: "1px", borderColor: "black", borderStyle: "dashed",
                        fontSize: "12px",
                        height: "92px",
                        textAlign: "center",
                        paddingTop: "10px",
                        marginTop: "5px"

                      }]}>
                        <Text>
                          For :{item.compname}
                        </Text>
                      </View>
                      <View style={[styles.font_bold,
                      {
                        textAlign: "center",
                      }]}>
                        <Text style={{ marginBottom: "3px" }}>Authorised signatory</Text>
                      </View>
                    </View>

                  </View>
                </View>
                {/* end footer */}
              </View>
            </>
          )
        })}
      </Page >
    </Document >
  )
}
export default RptDbcrNote


